import _ from 'lodash';

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties
  };
};

export const checkValidity = (value, rules) => {
  let isValid = true;
  if (!rules) {
    return true;
  }

  if (rules.required) {
    isValid = value.trim() !== '' && isValid;
  }

  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid
  }

  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid
  }

  if (rules.isUsername) {
    const pattern = /^[Pp][0-9]/;
    isValid = isValid && pattern.test(value)

  }

  if (rules.isName) {
    const pattern = /^[Pp][0-9]/;
    isValid = isValid && pattern.test(value)

  }

  if (rules.isNumeric) {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid
  }

  return isValid;
}

export const sortDataByKey = (data, key, sortflag = 'desc') => {
  const reverse = sortflag === 'asc' ?  1 : -1;
  return data.sort((a, b) => { 
    if(typeof (a[key]) === 'string') {
      if (a[key].toUpperCase() < b[key].toUpperCase()) return -1 * reverse;
      if (a[key].toUpperCase() > b[key].toUpperCase()) return 1 * reverse;
    } else {
      if (a[key] < b[key]) return -1 * reverse;
      if (a[key] > b[key]) return 1 * reverse;
    }   

    return 0;
  });
}

export const sortDataByProperty = (data, key, sortflag = 'desc') => {
  return _.orderBy(data, key, sortflag);
}
